module.exports = __webpack_public_path__ + "img/e9f1d716c7688994157176872cd8adf7.png";